import { render, staticRenderFns } from "./generic-text-input.vue?vue&type=template&id=128fdc79"
import script from "./generic-text-input.vue?vue&type=script&lang=js"
export * from "./generic-text-input.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/nortonpigozzo/Development/nisoftwares/VeinsEnergia-api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('128fdc79')) {
      api.createRecord('128fdc79', component.options)
    } else {
      api.reload('128fdc79', component.options)
    }
    module.hot.accept("./generic-text-input.vue?vue&type=template&id=128fdc79", function () {
      api.rerender('128fdc79', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/ui/inputs/generic-text-input.vue"
export default component.exports